import {FC} from "react";
import {CreateFeedbackModalProps} from "../../../types/feedback";
import {Modal, Spin} from "antd";
import FeedbackForm from "./components/feedback-form/FeedbackForm";
import {StarOutlined} from "@ant-design/icons";
import "./components/feedback-form/style.less";

const CreateFeedbackModal: FC<CreateFeedbackModalProps> = (props) => {
  const {staffController} = props
  const {feedbackForm, toggleCreateFeedbackModal, isCreateFeedbackModalOpen, isLoading} = staffController

  return <Modal
    width={620}
    centered
    className="feedback-modal"
    title={<div className="feedback-modal__title">
      <span className="feedback-modal__title-icon"><StarOutlined/></span>
      <span>
        <span className="feedback-modal__title-eyebrow">Ваша думка важлива</span>
        <span className="feedback-modal__title-text">Залишити відгук</span>
      </span>
    </div>}
    open={isCreateFeedbackModalOpen}
    onOk={() => feedbackForm.submit()}
    onCancel={toggleCreateFeedbackModal}
    okText="Надіслати відгук"
    cancelText="Скасувати"
    confirmLoading={isLoading}
    destroyOnClose
  >
    <Spin spinning={isLoading}>
      <FeedbackForm staffController={staffController}/>
    </Spin>
  </Modal>
}

export default CreateFeedbackModal
